import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    id: 0,
    uuid: "",
    name: "",
    email: "",
    phone: "",
    wx_openid: "",
  },
  reducers: {
    setAuth: (state, action) => {
      state.id = action.payload.id;
      state.uuid = action.payload.uuid;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.phone = action.payload.phone;
      state.wx_openid = action.payload.wx_openid || "";
    },
    // eslint-disable-next-line
    removeAuth: (state, action) => {
      state.id = 0;
      state.uuid = "";
      state.name = "";
      state.email = "";
      state.phone = "";
      state.wx_openid = "";
    },
  },
});

export const { setAuth, removeAuth } = authSlice.actions;

export default authSlice.reducer;
